module.exports = __webpack_public_path__ + "img/2_258.a9c121f4.png";